import React from 'react';


export const CrossIcon = props => (
  <svg {...props} viewBox="0 0 1000 1000">
    <path
      d="M926.9,990c-16.1,0-32.3-6.2-44.6-18.5L28.5,117.7c-24.7-24.7-24.7-64.5,0-89.2c24.7-24.7,64.5-24.7,89.2,0l853.7,853.7c24.7,24.7,24.7,64.5,0,89.2C959.1,983.8,943,990,926.9,990z"
    />
    <path
      d="M73.1,990c-16.1,0-32.3-6.2-44.6-18.5c-24.7-24.7-24.7-64.5,0-89.2L882.3,28.5c24.7-24.7,64.5-24.7,89.2,0s24.7,64.5,0,89.2L117.7,971.5C105.4,983.8,89.3,990,73.1,990z"
    />
  </svg>
);
